"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M9 12.879V15h2.121L20 6.121A1.5 1.5 0 1017.879 4L9 12.879z" }),
    React.createElement("path", { d: "M6 6h6V4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-2v6H6V6z" })), "Edit");
//# sourceMappingURL=Edit.js.map